import { jsx } from "react/jsx-runtime";
import classnames from "classnames";
import * as React from "react";
const namedClassNamesSoThatICanGrepForThis = {
  normal: "tlui-button__normal",
  primary: "tlui-button__primary",
  danger: "tlui-button__danger",
  low: "tlui-button__low",
  icon: "tlui-button__icon",
  tool: "tlui-button__tool",
  menu: "tlui-button__menu",
  help: "tlui-button__help"
};
const TldrawUiButton = React.forwardRef(
  function TldrawUiButton2({ children, type, isActive, ...props }, ref) {
    return /* @__PURE__ */ jsx(
      "button",
      {
        ref,
        type: "button",
        draggable: false,
        "data-isactive": isActive,
        ...props,
        className: classnames(
          "tlui-button",
          namedClassNamesSoThatICanGrepForThis[type],
          props.className
        ),
        children
      }
    );
  }
);
export {
  TldrawUiButton
};
//# sourceMappingURL=TldrawUiButton.mjs.map
